.calendarGridCell {
  --ixf-calendar-grid-cell-background: var(--ixf-color-background);
  --ixf-calendar-grid-cell-base-border-radius: var(--ixf-border-radius-2);
  --ixf-calendar-grid-cell-border-radius: var(--ixf-calendar-grid-cell-base-border-radius);
  --ixf-calendar-grid-cell-font-color: var(--ixf-text-tone-md);
  --ixf-calendar-grid-cell-padding: 2px;

  align-items: center;
  justify-content: center;

  &.isDisabled, &[aria-disabled="true"] {
    opacity: 0.3;

    button {
      cursor: default;
    }
  }

  &.isToday, &:focus-within {
    .content::before {
      border-radius: var(--ixf-calendar-grid-cell-border-radius);
      box-shadow: 0 0 0 2px var(--ixf-text-tone-md) inset;
      left: var(--ixf-calendar-grid-cell-padding);
    }
  }

  &.isRangeStart, &.isRangeEnd, &.isSelectedSingleDate {
    .content {
      --ixf-calendar-grid-cell-font-color: var(--ixf-color-background);

      &::before {
        --ixf-calendar-grid-cell-background: var(--ixf-text-tone-md);

        border: none;
        opacity: 1;
      }
    }
  }

  &.isWithinRange {
    .content::before {
      --ixf-calendar-grid-cell-border-radius: 0;
      --ixf-calendar-grid-cell-background: var(--ixf-color-neutral-md);

      border: none;
      left: 0;
      opacity: 1;
      width: 100%;
    }
  }

  &.isRangeEnd {
    .content::before {
      --ixf-calendar-grid-cell-border-radius: 0 var(--ixf-calendar-grid-cell-base-border-radius) var(--ixf-calendar-grid-cell-base-border-radius) 0;

      left: 0;
      width: calc(100% - var(--ixf-calendar-grid-cell-padding));
    }
  }

  &.isRangeStart {
    .content::before {
      --ixf-calendar-grid-cell-border-radius: var(--ixf-calendar-grid-cell-base-border-radius) 0 0 var(--ixf-calendar-grid-cell-base-border-radius);

      left: var(--ixf-calendar-grid-cell-padding);
      width: calc(100% - var(--ixf-calendar-grid-cell-padding));
    }
  }

  &.isUnavailable {
    opacity: 0.3;
  }

  .content {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    color: var(--ixf-calendar-grid-cell-font-color);
    font-size: var(--ixf-calendar-grid-cell-font-size);
    line-height: var(--ixf-calendar-grid-cell-line-height);
    font-weight: var(--ixf-calendar-grid-cell-font-weight);
    height: var(--ixf-calendar-grid-cell-height);
    min-width: var(--ixf-calendar-grid-cell-min-width);
    position: relative;
    cursor: pointer;
    z-index: 0;

    &::before {
      background: var(--ixf-calendar-grid-cell-background);
      border-radius: var(--ixf-calendar-grid-cell-border-radius);
      content: '';
      height: 100%;
      position: absolute;
      width: calc(100% - var(--ixf-calendar-grid-cell-padding) * 2);
      z-index: -1;
    }

    &:focus {
      outline: none;
    }
  }
}
